import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Star, Users, ThumbsUp } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Marcelo R.',
    location: 'Buenos Aires',
    text: 'Usé el Tomo 3 para mi primer cerramiento A30. Me quedaron $480.000 de ganancia neta. El combo se pagó solo en el primer trabajo.',
    time: '14:23'
  }, {
    name: 'Diego F.',
    location: 'Córdoba',
    text: 'Los scripts de WhatsApp del Bono 2 son oro puro. Cerré 3 trabajos en una semana que antes me hubiera perdido por no saber cómo responder.',
    time: '16:45'
  }, {
    name: 'Sebastián M.',
    location: 'Rosario',
    text: 'Llevaba 2 años trabajando a pérdida sin saberlo. El Tomo 5 me mostró exactamente dónde se me escapaba la plata. Game changer total.',
    time: '09:12'
  }];
  return <section className="bg-[#0A0A0A] py-14 px-4" data-id="element-237">
      <div className="container mx-auto max-w-5xl" data-id="element-238">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-8" data-id="element-239">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-240">
            Lo que dicen los carpinteros que ya lo usan
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10" data-id="element-241">
          {testimonials.map((testimo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-[#0b140b] border border-green-900/30 rounded-2xl p-6 shadow-lg relative" data-id="element-242">
              {/* WhatsApp tail */}
              <div className="absolute top-4 -left-2 w-4 h-4 bg-[#0b140b] border-l border-t border-green-900/30 transform -rotate-45" data-id="element-243"></div>

              <div className="flex justify-between items-start mb-3" data-id="element-244">
                <div data-id="element-245">
                  <h4 className="text-green-500 font-bold text-sm" data-id="element-246">
                    {testimo.name}
                  </h4>
                  <p className="text-gray-500 text-xs" data-id="element-247">{testimo.location}</p>
                </div>
                <div className="flex text-[#D4A017]" data-id="element-248">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-current" data-id="element-249" />)}
                </div>
              </div>

              <p className="text-gray-300 text-sm leading-relaxed mb-4" data-id="element-250">
                "{testimo.text}"
              </p>

              <div className="flex justify-between items-end mt-auto" data-id="element-251">
                <div className="flex items-center gap-1 text-green-500/80 text-xs font-medium bg-green-500/10 px-2 py-1 rounded" data-id="element-252">
                  <CheckCircle2 className="w-3 h-3" data-id="element-253" />
                  Compra verificada
                </div>
                <div className="text-gray-600 text-xs flex items-center gap-1" data-id="element-254">
                  {testimo.time}
                  <span className="text-blue-500" data-id="element-255">✓✓</span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: 0.4
      }} className="bg-[#111111] rounded-2xl p-6 border border-gray-800 flex flex-wrap justify-center gap-8 md:gap-16" data-id="element-256">
          <div className="flex items-center gap-3" data-id="element-257">
            <Users className="w-8 h-8 text-[#D4A017]" data-id="element-258" />
            <div data-id="element-259">
              <p className="text-white font-bold text-xl" data-id="element-260">+1.200</p>
              <p className="text-gray-400 text-sm" data-id="element-261">Compradores</p>
            </div>
          </div>
          <div className="flex items-center gap-3" data-id="element-262">
            <Star className="w-8 h-8 text-[#D4A017] fill-current" data-id="element-263" />
            <div data-id="element-264">
              <p className="text-white font-bold text-xl" data-id="element-265">4.9/5</p>
              <p className="text-gray-400 text-sm" data-id="element-266">Puntuación</p>
            </div>
          </div>
          <div className="flex items-center gap-3" data-id="element-267">
            <ThumbsUp className="w-8 h-8 text-[#D4A017]" data-id="element-268" />
            <div data-id="element-269">
              <p className="text-white font-bold text-xl" data-id="element-270">98%</p>
              <p className="text-gray-400 text-sm" data-id="element-271">Recomendarían</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}